import { Component, Optional, Inject, EventEmitter } from '@angular/core';
import { PlatformLocation } from '@angular/common';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { BaseComponent } from '../../../shared/base-components/base.component';
import { CustomerDetailService } from '../customer-detail.service';
import { OrganizationCustomer } from '../../models/organization-customer.model';
import { CustomerOrganizationType } from '../../models/enums/customer-organization-type.enum';
import { UntypedFormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { CustomerStatusType } from '../../../Foundation/models/enums/customer-status-type.enum';
import { AuthService } from '../../../auth/services/auth.service';
import { CustomerManageService } from '../../shared/customer-manage.service';
import { forkJoin } from 'rxjs';

export class OrganizationDetailModalContext {
    constructor(public customerNumberId: number,
        public ein: string,
        public customerStatusTypeId: number
    ) { }
}

@Component({
    selector: 'organization-customer-detail-modal',
    templateUrl: './organization-customer-details-modal.html'
})
export class OrganizationDetailModalComponent extends BaseComponent {
    public customerType = 0;
    public customerNumberId = 0;
    public organizationTypeList: any[] = new CustomerOrganizationType().GetActive();
    public orgDetailsForm: UntypedFormGroup;
    public organizationTypeId: number;
    public ein: string;
    public type = 'Organization';
    public id: number;
    public success = false;

    public canEdit = false;
    private customerStatusTypes: CustomerStatusType = new CustomerStatusType();
    public doNotUse = false;
    public customerStatusTypeId: number;
    public origionalStatus: number;

    constructor(
        public location: PlatformLocation,
        public dialogRef: MatDialogRef<OrganizationDetailModalComponent>,
        public customerService: CustomerDetailService,
        authService: AuthService,
        public fb: UntypedFormBuilder,
        public manageService: CustomerManageService,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: OrganizationDetailModalContext
    ) {
        super();

        this.canEdit = authService.hasACSTransactionClaimEx(authService.acsTransactionClaim, 'UpdCustomerActiveIndicator');
        this.customerNumberId = data.customerNumberId;
        this.ein = data.ein;
        this.doNotUse = data.customerStatusTypeId == this.customerStatusTypes.Closed.id;
        this.origionalStatus = data.customerStatusTypeId;
        location.onPopState(() => {
            this.dialogRef.close();
        });
    }

    ngOnInit() {
        this.customerService.getCustomerOrganization(this.customerNumberId).subscribe(
            res => {
                this.organizationTypeId = res.result[0].customerOrganizationTypeId;
                this.id = res.result[0].id;
            });
    }

    /**
     * Cancel and close modal.
     */
    cancel() {
        this.dialogRef.close(this.origionalStatus);
    }

    successfulCancel() {
        this.dialogRef.close(this.customerStatusTypeId);
    }

    save() {
        var data = new OrganizationCustomer();
        data.id = this.id;
        data.customerNumberID = this.customerNumberId;
        if (this.organizationTypeId) {
            data.customerOrganizationTypeId = +this.organizationTypeId;
        }
        data.effectiveDate = '1/1/2020';
        data.endDate = null;

        if (this.doNotUse == true) {
            this.customerStatusTypeId = this.customerStatusTypes.Closed.id;
        } else {
            this.customerStatusTypeId = this.customerStatusTypes.Active.id;
        }

        const obs = forkJoin({
            updateOrganization: this.customerService.updateCustomerOrganization(data),
            statusUpdate: this.manageService.updateStatus(data.customerNumberID, this.customerStatusTypeId)
        });

        obs.subscribe(
            result => {
                this.success = true;
            },
            error => {
                this.handleValidationResult(error);
            }
        );
    }
}
